import React from 'react';
import {
  Flex,
  VStack,
  Icon,
  Text,
  Box,
  Circle,
} from '@chakra-ui/react';
import { FiGrid, FiBell, FiPieChart } from 'react-icons/fi';

/**
 * Reusable bottom navigation component
 * Used across the app for consistent navigation experience
 */
const BottomNavigation = ({
  activeTab = 'agenda',
  onTabChange,
  notifications = [],
  tabs = [
    {
      id: 'agenda',
      label: 'Agenda',
      icon: FiGrid,
      color: 'dark.500',
    },
    {
      id: 'news',
      label: 'News',
      icon: FiBell,
      color: 'gray.500',
      showNotificationBadge: true,
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: FiPieChart,
      color: 'gray.500',
    },
  ],
  ...props
}) => {
  const handleTabClick = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <Flex
      position="fixed"
      bottom={0}
      left="50%"
      transform="translateX(-50%)"
      bg="white"
      borderTop="1px solid"
      borderColor="gray.200"
      px={6}
      w="424px"
      py={2}
      justify="space-around"
      align="center"
      zIndex={10}
      {...props}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const iconColor = isActive ? (tab.color || 'dark.500') : 'gray.500';
        const textColor = isActive ? (tab.color || 'dark.500') : 'gray.500';
        const hasNotifications = tab.showNotificationBadge && notifications?.length > 0;

        return (
          <VStack
            key={tab.id}
            spacing={1}
            cursor="pointer"
            onClick={() => handleTabClick(tab.id)}
            opacity={isActive ? 1 : 0.6}
            position="relative"
            transition="all 0.2s"
            _hover={{
              opacity: 1,
              transform: 'translateY(-1px)',
            }}
            _active={{
              transform: 'translateY(0px)',
            }}
            data-testid={`bottom-nav-${tab.id}`}
          >
            <Box position="relative">
              <Icon 
                as={tab.icon} 
                boxSize={5} 
                color={iconColor}
                transition="color 0.2s"
              />
              {hasNotifications && (
                <Circle
                  size="10px"
                  bg="green.400"
                  position="absolute"
                  top={-1}
                  right={-1}
                  border="2px solid white"
                  data-testid={`notification-badge-${tab.id}`}
                />
              )}
            </Box>
            <Text 
              fontSize="11px" 
              color={textColor}
              fontWeight={isActive ? "600" : "400"}
              transition="color 0.2s"
            >
              {tab.label}
            </Text>
          </VStack>
        );
      })}
    </Flex>
  );
};

export default BottomNavigation;
